import React from 'react'
import { Layout as LayoutAnt } from 'antd';
const { Footer } = LayoutAnt;

export default function FooterCustom() {
    return (
        <Footer style={{ textAlign: 'center' }}>Business Management System</Footer>
    )
}